export default __webpack_public_path__ + "static/media/io_bg.6e154acd.png";